/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export interface IMedicationSchedule {
  id?: string;
  name?: string;
  tmValue?: string;
  timestampentry?: number;
  active?: boolean;
  lastupdated?: number;
  cursor?: number;
  microSec?: number;
  shortCode?: string | null;
  lang?: string | null;
  sortOrder?: number;
}

export const defaultValue: Readonly<IMedicationSchedule> = {
  active: false,
};
